import { utilityServicesPath} from "../../Constants";
import axios from "axios";

const restUrl = utilityServicesPath + '/user/vacancies'

export default class UserVacanciesService {

    static async get() {
        return axios.get(restUrl, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }
}